var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{attrs:{"width":"100%","height":"100%","src":`https://www.youtube.com/embed/${_vm.id}?autoplay=${Number(_vm.autoplay)}`,"title":"YouTube video player","frameborder":"0","allow":`accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; ${
    _vm.autoplay ? 'autoplay;' : ''
  }`,"allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }